// App.tsx or wherever AddInvite is used
import React from "react"
import { InviteProvider } from "./context"
import AddInvite from "./addInvite"

const AddInviteHome: React.FC = () => {
  return (
    <InviteProvider>
      <AddInvite />
    </InviteProvider>
  )
}

export default AddInviteHome
